import styled from 'styled-components/macro';

export const LastVisitorTableHeading = styled.th`
  background-color: whitesmoke;
`;

export const DescriptionColumn = styled.td`
  max-width: 200px;
`;

export const DeactivateColumn = styled.td`
  max-width: 120px;
`;
